// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function PilotDragPanel(props) {
  return React.createElement("div", {
              className: "pilotDragPanel"
            }, props.children);
}

var make = PilotDragPanel;

export {
  make ,
}
/* react Not a pure module */
